import { withModal, confirmModal } from '@tls/ui-modal';

import { ModalNames } from './constants';

export default withModal(confirmModal, ModalNames.SHARED_CONFIRM_MODAL);
